import { isWithinLast } from '../is-within-last/index.tsx';

export const isWithinLast30Days = isWithinLast({ days: 30 });
